import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSharedComponentsModule, LayoutModule } from '@monsido/angular-shared-components';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PrivacyDialogComponent } from './popup/privacy-dialog.component';
import { PrivacyDialogModernComponent } from './popup/privacy-dialog-modern.component';
import { TranslateModule } from '@client/app/modules/translate.module';
import { TranslocoModule } from '@jsverse/transloco';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';

@NgModule({
    declarations: [
        PrivacyDialogComponent,
        PrivacyDialogModernComponent,
    ],
    imports: [
        AngularSharedComponentsModule,
        LayoutModule,
        FormsModule,
        TranslateModule,
        CommonModule,
        NgbModule,
        CheckboxModule,
        ButtonModule,
        TranslocoModule,
    ],
    providers: [
        DialogService,
    ],
    exports: [
        PrivacyDialogComponent,
        PrivacyDialogModernComponent,
    ],
})
export class TermsModule { }
